import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M4.262 6.233a2.075 2.075 0 1 1 4.15 0 2.075 2.075 0 0 1-4.15 0Zm2.076-.575a.575.575 0 1 0 0 1.15.575.575 0 0 0 0-1.15Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M1.948 3.582c0-.9.733-1.633 1.633-1.633h8.835c.9 0 1.634.733 1.634 1.633v8.835c0 .9-.734 1.634-1.634 1.634H3.581c-.9 0-1.633-.733-1.633-1.634V3.582ZM3.58 3.45a.136.136 0 0 0-.133.133v8.835c0 .072.062.134.133.134h.04l2.028-3.038c.215-.328.566-.549.942-.61.415-.074.808.051 1.103.277l.012.01.47.375 1.301-1.863a1.416 1.416 0 0 1 2.325.009l.01.014.738 1.11V3.581a.136.136 0 0 0-.134-.133H3.581Zm8.969 8.092-1.915-2.877-1.686 2.415a.75.75 0 0 1-1.083.157l-1.02-.814-1.422 2.129h6.992a.136.136 0 0 0 .134-.134v-.876Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  c,
  n
];
function r(a, s) {
  return l(), o("svg", t, [...d]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
